<template>
  <div class="wrap">
    <div class="row justify-content-center">
      <div class="col-12 content">
        <Twitch />
      </div>
    </div>
  </div>
</template>

<script>
import Twitch from "Components/Sections/Twitch.vue";
export default {
  name: "Livestream",
  components: {
    Twitch,
  },
};
</script>
<style scoped>
#mainNav {
  display: none !important;
}

.wrap {
  background-color: black !important;
  font-family: "Roboto Condensed", sans-serif;
  width: 100%;
  padding-top: 10vh;
}
</style>


